<template>
  <div>
    <div v-if="examInfo">
      <div class="user-header">
        <div class="user-name-row">
          <div class="user-name">{{examInfo.name}}</div>
          <div class="btn-wrap">
            <div class="logout-btn" @click="getExamInfo()">刷新</div>
          </div>
        </div>
        <div class="user-info-row">体检日期：{{examInfo.examDate}}</div>
        <div class="user-info-row">体检编号：{{examInfo.examNo}}</div>
        <div class="user-info-row">手机号码：{{examInfo.mobile|mask("phone")}}</div>

      </div>
      <div class="wrapper">
        <div class="card-body" v-show="false">
          <div>
            <div class="queue-head">
              <div class="queue-head__station">
                <span>当前诊室</span>
                <h2>{{examInfo.name}}</h2>
              </div>
              <div class="queue_head__position">
                <span>诊室编号</span>
                <h2 class="van-coupon__name">{{examInfo.name}}</h2>
              </div>
              <div class="queue_head__position" v-show="false">
                <span>当前位置</span>
                <h2 class="van-coupon__name">第{{examInfo.name}}位</h2>
              </div>
            </div>
            <div class="division">
              <div class="division-line"></div>
            </div>
            <div class="queue-info">
              <div class="queue-info__row">
                <p class="queue-info__label">诊室位置</p>
                <p class="queue-info__value">{{examInfo.name}}</p>
              </div>
              <!-- <div class="queue-info__row">
              <p class="queue-info__label">等候时间</p>
              <p class="queue-info__value">预计 {{currentQueue.ExpectedWaitTime}} 分钟</p>
            </div> -->
              <div class="queue-info__row">
                <p class="queue-info__label">温馨提示</p>
                <p class="queue-info__value">请依次耐心等候</p>
              </div>
            </div>
          </div>

        </div>
        <div class="card-body">

          <div class="queue-info">
            <div class="queue-info__row">
              <p class="queue-info__label">单位</p>
              <p class="queue-info__value">{{examInfo.companyName}}</p>
            </div>
            <div class="queue-info__row">
              <p class="queue-info__label">体检记录</p>
              <p class="queue-info__value">{{examInfo.companyBatchName}}</p>
            </div>
            <div class="queue-info__row">
              <p class="queue-info__label">体检套餐</p>
              <p class="queue-info__value">{{examInfo.packageName}}</p>
            </div>
            <!-- <div class="queue-info__row">
              <p class="queue-info__label">等候时间</p>
              <p class="queue-info__value">预计 {{currentQueue.ExpectedWaitTime}} 分钟</p>
            </div> -->
            <div class="queue-info__row">
              <p class="queue-info__label">温馨提示</p>
              <p class="queue-info__value">{{examInfo.notice}}</p>
            </div>
          </div>
          <div class="barcode-wrap">
            <img id="barcode1"></img>
          </div>
        </div>
        <div class="card-body">
          <div>
            <div class="item-wrapper" v-if="examInfo && examInfo.items">
              <div class="item-header">体检项目</div>
              <ul>
                <li v-for="(item,i) in examInfo.items" :key="i" class="item__row">
                  <div class="item-name">
                    {{item.name}}
                    <span class="item-status">
                      <!-- <van-icon name="clock-o" size="16" color="#666666" /> -->
                      {{item.status}}
                    </span>
                  </div>
                  <div class="item-notice">{{item.notice}}</div>
                </li>
              </ul>
            </div>

            <div class="empty-wrapper" v-show="false">
              <img src="@/assets/images/icon-success.png" />
              <p>已完成所有项目，请到前台交回导检单</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-empty" v-else>
      <van-empty image="search" description="未找到体检记录" />
    </div>
  </div>
</template>


<script>
  import Vue from "vue";
  import JsBarcode from 'jsbarcode'
  import {
    Icon
  } from "vant";
  Vue.use(Icon);

  import {
    Tab,
    Tabs,
    Button
  } from "vant";
  Vue.use(Tab)
    .use(Tabs)
    .use(Button);

  import {
    Popup
  } from "vant";
  Vue.use(Popup);

  import {
    Cell,
    CellGroup
  } from "vant";
  Vue.use(Cell).use(CellGroup);

  import {
    Step,
    Steps
  } from "vant";
  Vue.use(Step).use(Steps);

  import * as exam_api from '@/api/exam.js';

  export default {
    data() {
      return {
        state: {},
        examInfo: null,
        show: false,
        tabIndex: 0,
        timer: null,
      };
    },
    mounted() {
      this.getExamInfo();
    },
    beforeDestroy() {
      this.clearTimer();
    },
    methods: {
      getExamInfo() {
        var hospId = this.$route.query.hospId;
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '查询中',
        });
        exam_api.getExamInfo(hospId).then(res => {
          if (res.code !== 200) {
            this.$toast(res.msg)
          } else {
            console.log(res.data);
            this.examInfo = res.data;
            setTimeout(() => {
              this.createBarcode();
            }, 1500);
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.$toast.clear();
        })
      },
      clearTimer() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      createBarcode() {
        JsBarcode("#barcode1", this.examInfo.examNo, {
          format: "CODE128", //条形码的格式
          width: 1.5, //线宽
          height: 70, //条码高度
          lineColor: "#000", //线条颜色
          displayValue: false, //是否显示文字
          margin: 2 //设置条形码周围的空白区域
        })
      }
    },
  };
</script>

<style lang="less" scoped>
  .content-empty {
    min-height: 100vh;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wrapper {
    margin-top: 160px;
    position: relative;
  }

  .barcode-wrap {
    text-align: center;
    margin-bottom: 16px;
  }

  .user-header {
    height: 200px;
    padding: 16px 28px;
    background-image: linear-gradient(0deg, #89f7fe 0%, #66a6ff 100%);
    // background-color: #ffb937;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 0;
    color: #fff;

    .user-name-row {
      display: flex;

      .user-name {
        font-size: 24px;
        line-height: 40px;
        color: #fff;
        flex: 1
      }

      .btn-wrap {
        .logout-btn {
          margin: 8px;
          border: 1px solid #fff;
          padding: 4px 10px;
          border-radius: 12px;
          line-height: 12px;
          font-size: 13px;
          background-color: #59595930;
        }
      }

    }


    .user-info-row {
      font-size: 14px;
      line-height: 32px;
    }
  }

  .card-body {
    margin: 0 16px 16px 16px;
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
    z-index: 2;
  }

  .queue-head {
    display: flex;
    margin: 12px 16px 0px 16px;

    .queue-head__station {
      flex: 1;
    }

    h2 {
      font-size: 18px;
      font-weight: 400;
      margin: 16px 0px;
    }

    .item-status {
      font-size: 16px;
      color: #888888;
    }



    span {
      color: #bababa;
    }
  }

  .division {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden;
    height: 16px;
    z-index: 2;
  }

  .division::before {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    left: -8px;
    top: 0;
    background-color: #f3f3f3;
    border-radius: 8px;
    z-index: 3;
  }

  .division::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    right: -8px;
    top: 0;
    background-color: #f3f3f3;
    border-radius: 8px;
    z-index: 3;
  }

  .division-line {
    margin: 0 0.4rem;
    width: 100%;
    height: 0;
    border-bottom: 1px dashed #e4e4e4;
    transform: scaleY(0.51);
  }

  .queue-info {
    margin: 16px;
    font-size: 14px;

    .queue-info__row {
      display: flex;
      line-height: 28px;
    }

    .queue-info__label {
      color: #888888;
      width: 80px;
    }

    .queue-info__value {
      flex: 1;
    }
  }

  .block-title {
    margin: 0;
    padding: 24px 16px 16px;
    color: rgba(69, 90, 100);
    font-weight: normal;
    font-size: 18px;
    text-align: center;
  }

  h3 {
    margin: 0;
    font-weight: normal;
    font-size: inherit;
  }

  .popup-wrapper {
    padding: 20px;
    background-color: #eff2f7;
    text-align: center;

    .sawtooth {
      padding: 20px 0px;
      /* 相对定位，方便让before和after伪元素绝对定位偏移 */
      position: relative;
      border-top: 5px solid rgb(235, 235, 235);
      // box-sizing: border-box;
      // box-shadow: 0px -6px 4px 0 rgba(0, 0, 0, 0.05);
      background: #ffffff;

      .content-title {
        font-size: 18px;
        text-align: center;
        line-height: 48px;
      }
    }

    .sawtooth:after {
      content: " ";
      height: 0;
      width: 100%;
      /* 绝对定位进行偏移 */
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .sawtooth:after {
      /* 圆点型的border */
      border-bottom: 10px dotted #eff2f7;
      /* 偏移一个半径，让圆点的一半覆盖p */
      bottom: -5px;
    }

    .discount {
      border-right: 1px dashed #f5f5f5;
      padding: 10px;
      flex: 1;
      box-sizing: border-box;
      background-color: #ffffff;
    }

    .receive {
      text-align: center;
      width: 102px;
      line-height: 90px;
      height: 90px;
      box-sizing: border-box;
      margin-right: 5px;
      background-color: #ffb937;
    }

    .ticket-wrapper {
      margin: 10px 0;
      display: flex;

      .ticket-item {
        flex: 1;

        .ticket-item-title {
          font-size: 14px;
          color: #888888;
          margin-bottom: 10px;
        }

        .ticket-item-result {
          font-size: 18px;
        }
      }
    }

    .popup-footer {
      margin-top: 10px;

      .van-button {
        width: 100%;
      }
    }
  }

  .item-wrapper {
    .item-header {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      margin: 16px 0;
    }

    .item__row {
      padding: 12px;
      border-bottom: 1px solid #f2f2f2;

      .item-name {
        font-size: 14px;
        margin-bottom: 8px;
      }

      .item-status {
        font-size: 14px;
        float: right;
      }

      .item-notice {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.6);
      }

      .item-footer {
        display: flex;
        margin-top: 8px;

        .complete-time {
          color: #888888;
          font-size: 13px;
          line-height: 25px;
          flex: 1;
        }

        .comment-wrap {
          .van-button--mini {
            padding: 0 8px;
          }
        }
      }
    }
  }

  .empty-wrapper {
    img {
      height: 80px;
      margin: 32px;
    }

    height: 360px;
    text-align: center;
  }
</style>